import { BrandBase as BrandBaseGQL } from '@abstractTypes/graphqlTypes'

export type BrandBase = Omit<BrandBaseGQL, '__typename'>

export const NUANCE_BRAND = 'AW'
export const SUPERNOVA_BRAND = 'RW'
